export { default as CategoriesIndexTablePagination } from './CategoriesIndexTablePagination';
